import React, { useCallback, useMemo, } from 'react';
import { ModelSelectionUndoState } from '../ModelSelectionPage';
import DicomRuleForm from '../DicomRuleForm';
import { ModelType } from '../../../store/global-types/customization-types';
import { useDispatch, useSelector } from 'react-redux';
import { StoreState } from '../../../store/store';
import { createNewDicomAttributeRule } from '../../../store/global-types/customization-helpers';
import { literalTextToRegex } from '../../../util/string-convert';
import { dicomAttributeRuleAdded, dicomRuleRemoved, imageSelectors } from '../../../store/image/imageSlice';
import { makeSelectFormValidationErrorsForDicomRule } from '../../../store/image/imageSelectors';




interface ImageDicomRuleProps {
    dicomRuleId: string,
    runningNumber: number,
    isLastRule: boolean,
    setUndoState: (undoState: ModelSelectionUndoState) => void,
    isUndoDisabled?: boolean,
    getDicomAttributeRule: (id: string, runningNumber: number, onRemoveDicomRuleButtonClicked: () => void) => JSX.Element,
}

const ImageDicomRule = (props: ImageDicomRuleProps) => {
    const { dicomRuleId, runningNumber, isLastRule, setUndoState, isUndoDisabled, getDicomAttributeRule } = props;

    const dispatch = useDispatch();

    const dicomRule = useSelector((state: StoreState) => imageSelectors.selectDicomRuleById(state, dicomRuleId));
    const validationError = useSelector((state: StoreState) => imageSelectors.selectCustomizationValidationError(state, dicomRuleId));

    const selectFormValidationErrorsForRule = useMemo(makeSelectFormValidationErrorsForDicomRule, []);
    const formValidationErrors = useSelector((state: StoreState) => selectFormValidationErrorsForRule(state, dicomRuleId));

    const handleCreateNewDicomAttributeRule = useCallback(() => {
        const newAttribute = createNewDicomAttributeRule('', literalTextToRegex(''), dicomRuleId, true);
        dispatch(dicomAttributeRuleAdded(newAttribute));
    }, [dispatch, dicomRuleId]);

    const handleRemoveDicomRule = useCallback(() => {
        dispatch(dicomRuleRemoved(dicomRuleId));
    }, [dispatch, dicomRuleId]);

    if (dicomRule === undefined) {
        return null;
    }

    return (
        <DicomRuleForm 
            modelType={ModelType.Image}
            dicomRule={dicomRule}
            validationError={validationError}
            formValidationErrors={formValidationErrors}
            runningNumber={runningNumber}
            isLastRule={isLastRule}
            setUndoState={setUndoState}
            isUndoDisabled={isUndoDisabled}
            onCreateNewDicomAttributeRule={handleCreateNewDicomAttributeRule}
            onDicomRuleRemoved={handleRemoveDicomRule}
            getDicomAttributeRule={getDicomAttributeRule}
        />
    );
}

export default ImageDicomRule;
